import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * Generate a PDF from table data
 * @param {string} headerName - Title/header of the PDF
 * @param {Array} columns - AntD style columns [{ title, dataIndex }]
 * @param {Array} dataSource - Table data [{ key, ... }]
 */
export const generatePDF = (headerName, columns, dataSource) => {
  const doc = new jsPDF();

  // Add header text
  doc.setFontSize(14);
  doc.text(headerName, 18, 15);

  // Extract table column titles & rows
  const tableColumn = columns.map((col) => col.title);
  const tableRows = dataSource.map((row, index) =>
    columns.map((col, colIndex) => (colIndex === 0 ? index + 1 : row[col.dataIndex]))
  );

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 25,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [41, 128, 185] }, // blue header
    didParseCell: (data) => {
      // Make "Total" row bold
      if (
        data.section === "body" &&
        String(data.row.raw[2]).toLowerCase() === "total"
      ) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [230, 230, 230]; // light grey background
      }
    },
  });

  doc.save(`${headerName}.pdf`);
};
